
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from '@/locales/en/common.json';
import deCommon from '@/locales/de/common.json';
import enAuth from '@/locales/en/auth.json';
import deAuth from '@/locales/de/auth.json';
import enDashboard from '@/locales/en/dashboard.json';
import deDashboard from '@/locales/de/dashboard.json';
import enChallenges from '@/locales/en/challenges.json';
import deChallenges from '@/locales/de/challenges.json';
import enMemory from '@/locales/en/memory.json';
import deMemory from '@/locales/de/memory.json';
import enFriends from '@/locales/en/friends.json';
import deFriends from '@/locales/de/friends.json';
import enLanding from '@/locales/en/landing.json';
import deLanding from '@/locales/de/landing.json';
import enTimeline from '@/locales/en/timeline.json';
import deTimeline from '@/locales/de/timeline.json';
import enProfile from '@/locales/en/profile.json';
import deProfile from '@/locales/de/profile.json';
import enValidation from '@/locales/en/validation.json';
import deValidation from '@/locales/de/validation.json';
import enChangelog from '@/locales/en/changelog.json';
import deChangelog from '@/locales/de/changelog.json';

console.log('🌐 i18n initialization - loaded timeline translations:', {
  enTimeline,
  deTimeline
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'de',
    debug: false,
    
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        dashboard: enDashboard,
        challenges: enChallenges,
        memory: enMemory,
        friends: enFriends,
        landing: enLanding,
        timeline: enTimeline,
        profile: enProfile,
        validation: enValidation,
        changelog: enChangelog,
      },
      de: {
        common: deCommon,
        auth: deAuth,
        dashboard: deDashboard,
        challenges: deChallenges,
        memory: deMemory,
        friends: deFriends,
        landing: deLanding,
        timeline: deTimeline,
        profile: deProfile,
        validation: deValidation,
        changelog: deChangelog,
      }
    },

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  })
  .then(() => {
    console.log('🌐 i18n initialized successfully with languages:', Object.keys(i18n.store.data));
    console.log('🌐 Timeline resources loaded:', {
      en: !!i18n.store.data.en?.timeline,
      de: !!i18n.store.data.de?.timeline
    });
    console.log('🌐 Profile resources loaded:', {
      en: !!i18n.store.data.en?.profile,
      de: !!i18n.store.data.de?.profile
    });
  })
  .catch((error) => {
    console.error('🌐 i18n initialization failed:', error);
  });

export default i18n;
